import { Component, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { AllapiService } from '../allapi.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../auth.service';
import { BrowserModule, Title, Meta } from '@angular/platform-browser';
import { slugify as translitSlug } from 'transliteration';
import { LanguagePopupComponent } from '../language-popup/language-popup.component';
import { LanguageService } from '../language.service';
import { TranslationService } from '../translation.service';
import { PromotionService } from '../promotion.service';


interface SponsoredStoriesResponse {
  status: string;
  sponsored_stories: any[];
  click_cost?: number;
}
interface EnhancedSponsoredStory {
  promotion_id: number;
  story_id: number;
  story_title: string;
  story_image: string;
  category: string;
  language: string;
  description: string;
  author_name: string;
  promotion_balance: number;
  episodes_count: number;
  isSponsored: boolean;
  sponsoredBadge: boolean;
  click_cost?: number;
}
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeaderComponent, CommonModule, RouterModule, LanguagePopupComponent],
  providers:[Title, Meta],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent  {
  stories: any[] = [];
  libraryMessage = '';
  categoryColumns: any[] = [];
  likedStories: number[] = [];
  userId: string | null = null;
  storyImgPath = 'https://stories.funtelstudio.com/storyapi';
  userProgress: any[] = [];
isLoggedIn: boolean = true;
sponsoredStories: any[] = [];
  topAuthors: {
    author_name: string;
    user_id: string;
    views: number;
    story_count: number;
    profileImg?: string;
  }[] = [];

  isFollowingMap: { [authorId: string]: boolean } = {};

  latestStories: any[] = [];
  allLatestStories: any[] = [];
  showAllLatest = false;

  visibleCategories: any[] = [];
  showAllCategories = false;

  trendingStories: any[] = [];

   private isMouseDown: boolean = false;
  private startX: number = 0;

  private velocity: number = 0;
  private lastX: number = 0;
  private timestamp: number = 0;
  private rafId: number | null = null;
  otherLanguageStories: any[] = [];
currentOtherLangSlide = 0;
showOtherLanguages = false;

  // ---- carousel refs ----
  @ViewChild('carousel', { static: false }) carousel!: ElementRef;
  currentSlideIndex = 0;
  slideWidth = 0;
  isDragging = false;
  startPos = 0;
  currentTranslate = 0;
  prevTranslate = 0;
  categoryWiseStories: { [category: string]: any[] } = {};
categoryOrder: string[] = [];
featuredStories: any[] = [];
selectedLanguage: string = 'en';


  constructor(
    private allApi: AllapiService,
    private http: HttpClient,
    public router: Router,
    private authService: AuthService,
    private titleService: Title, private meta: Meta,
    private languageService: LanguageService,
    public translationService: TranslationService,
    private promotionService: PromotionService
  ) {}
private isVerticalScroll: boolean = false;
private touchStartX: number = 0;
private touchStartY: number = 0;
private readonly VERTICAL_SCROLL_THRESHOLD = 5;
  // ---------------- lifecycle ----------------
  ngOnInit(): void {
    this.languageService.currentLanguage$.subscribe(lang => {
      this.selectedLanguage = lang;
      this.refreshAllData(); 
    });
    this.translationService.currentLang$.subscribe(() => {
      
    });


    this.selectedLanguage = this.languageService.getCurrentLanguage();

    
    this.titleService.setTitle('Funtel Studio Read Stories, Web Series &amp; TV Shows Online in HD');
    this.meta.updateTag({
      name: 'description',
      content: 'Stream the latest Story, trending web series, and TV shows in HD on Funtel Studio. Enjoy uninterrupted entertainment with a vast collection of content across genres, anytime and anywhere.'
    });

    // Meta Keywords
    this.meta.updateTag({
      name: 'keywords',
      content: 'Funtel, Read Story'
    });

    const userId = this.authService.getCurrentUserId();
    this.getAllStories();
    this.getCategory();
    this.loadLikedStories();
    this.loadUserStoryProgress();
    this.getAllCategoryStories();
    this.loadOtherLanguageStories(); 
    this.loadSponsoredStories();
  }
  t(key: string): string {
    return this.translationService.translate(key);
  }
refreshAllData() {
  console.log('🔄 Refreshing all data for language:', this.selectedLanguage);
  this.getAllStories();
  this.getAllCategoryStories();
  this.loadOtherLanguageStories();
}
  ngAfterViewInit() {
    this.calculateSlideWidth();
    this.setupCarousel();
  }

  // ---------------- carousel helpers ----------------
  @HostListener('window:resize')
  onResize() { this.calculateSlideWidth(); }

  calculateSlideWidth() {
    if (this.carousel?.nativeElement?.firstElementChild) {
      this.slideWidth = this.carousel.nativeElement.firstElementChild.clientWidth;
    }
  }
  setupCarousel() {
  const c = this.carousel.nativeElement;
  
  // Mouse events
  c.addEventListener('mousedown', (e) => this.startDrag(e));
  c.addEventListener('mouseleave', () => this.endDrag());
  c.addEventListener('mouseup', () => this.endDrag());
  c.addEventListener('mousemove', (e) => this.dragMove(e));
  
  // Touch events with improved handling
  c.addEventListener('touchstart', (e) => this.touchStart(e), { passive: true });
  c.addEventListener('touchend', () => this.touchEnd());
  c.addEventListener('touchmove', (e) => this.touchMove(e), { passive: false });
}

 startDrag(e: MouseEvent | TouchEvent) {
  // For touch events, we've already handled this in touchStart
  if (e.type !== 'touchstart') {
    this.isDragging = true;
    this.startPos = this.getPositionX(e);
    this.carousel.nativeElement.style.cursor = 'grabbing';
  }
}
createNewStory(): void {
    if (this.isLoggedIn) {
      this.router.navigate(['/new']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  navigateToLogin(): void {
  this.router.navigate(['/login']);
}
exploreAllLanguages(){
  this.router.navigateByUrl('/allstories')
}
touchStart(e: TouchEvent) {
  this.touchStartX = e.touches[0].clientX;
  this.touchStartY = e.touches[0].clientY;
  this.isVerticalScroll = false;
}
touchMove(e: TouchEvent) {
  if (!this.touchStartX || !this.touchStartY) return;
  
  const touchX = e.touches[0].clientX;
  const touchY = e.touches[0].clientY;
  
  const diffX = Math.abs(touchX - this.touchStartX);
  const diffY = Math.abs(touchY - this.touchStartY);
  
  
  if (!this.isVerticalScroll && diffY > this.VERTICAL_SCROLL_THRESHOLD && diffY > diffX) {
    this.isVerticalScroll = true;
    return; 
  }
  
  
  if (!this.isVerticalScroll && diffX > diffY) {
    e.preventDefault();
    
    
    if (!this.isDragging) {
      this.isDragging = true;
      this.startPos = this.touchStartX;
      this.prevTranslate = this.currentTranslate;
    }
    
    
    this.currentTranslate = this.prevTranslate + touchX - this.startPos;
    this.carousel.nativeElement.style.transform = `translateX(${this.currentTranslate}px)`;
  }
}
getOtherLanguageStories(): any[] {
  return this.otherLanguageStories.slice(0, 6); // Pehle 6 stories dikhao
}
scrollOtherLanguages(direction: number) {
  const container = document.querySelector('.other-languages-carousel');
  if (container) {
    const scrollAmount = 300; // Adjust as needed
    container.scrollBy({ 
      left: direction * scrollAmount, 
      behavior: 'smooth' 
    });
  }
}

touchEnd() {
  this.isDragging = false;
  this.prevTranslate = this.currentTranslate;
  this.touchStartX = 0;
  this.touchStartY = 0;
  this.isVerticalScroll = false;
}
  endDrag() {
    this.isDragging = false;
    this.prevTranslate = this.currentTranslate;
    this.carousel.nativeElement.style.cursor = 'grab';
  }
  dragMove(e: MouseEvent) {
  if (!this.isDragging) return;
  e.preventDefault();
  const currentPosition = this.getPositionX(e);
  this.currentTranslate = this.prevTranslate + currentPosition - this.startPos;
  this.carousel.nativeElement.style.transform = `translateX(${this.currentTranslate}px)`;
}
  getPositionX(e: MouseEvent | TouchEvent): number {
    return e.type.includes('mouse')
      ? (e as MouseEvent).pageX
      : (e as TouchEvent).touches[0].clientX;
  }
  scrollCarousel(direction: number) {
    this.currentSlideIndex = Math.max(
      0,
      Math.min(this.currentSlideIndex + direction, this.latestStories.length - 1)
    );
    const scrollAmount = this.currentSlideIndex * this.slideWidth;
    this.carousel.nativeElement.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  }

  filterStoriesByLanguage(stories: any[]): any[] {
    if (!stories) return [];
    return stories.filter(story => {
      
      return story.language === this.selectedLanguage || 
             !story.language || 
             this.selectedLanguage === 'en'; 
    });
  }

  // ---------------- path helpers ----------------
  private normPath(p: string | null | undefined): string {
    return p ? p.replace(/^\/+/, '') : '';
  }
  private fullAsset(rel?: string): string {
    const path = this.normPath(rel?.trim() || '');
    return path ? `${this.storyImgPath}/${path}` : '';
  }

  // ---------------- decorate story w/ author assets ----------------
  /** Normalizes API record; returns new object. */
  private decorateStory(raw: any): any {
    const rec = { ...raw };

    const profRaw  =
      rec.profileImg ??
      rec.profileimg_url ??
      rec.profileimg ??
      '';
    const coverRaw =
      rec.coverImg ??
      rec.coverimage_url ??
      rec.coverimage ??
      '';
    rec.authorProfileUrl = this.fullAsset(profRaw);
    rec.authorCoverUrl   = this.fullAsset(coverRaw);
    rec.authorInitial    = rec.author_name
      ? rec.author_name.trim().charAt(0).toUpperCase()
      : 'U';

    // numeric safe values
    rec.views          = +rec.views || 0;
    rec.average_rating = +rec.average_rating || 0;
    rec.total_ratings  = +rec.total_ratings || 0;

    return rec;
  }
getEmptyStateMessage(): string {
    const messages: { [key: string]: string } = {
      'en': 'No stories available yet.',
      'hi': 'यहाँ अभी तक कोई कहानियाँ उपलब्ध नहीं हैं।',
      'mr': 'येथे अद्याप कथा नाहीत.',
      'bn': 'এখানে এখনও কোন গল্প পাওয়া যায়নি।',
      'ta': 'இங்கு இன்னும் கதைகள் எதுவும் இல்லை.',
      'te': 'ఇంకా ఇక్కడ కథలు లేవు.'
    };
    return messages[this.selectedLanguage] || messages['en'];
  }

  getEmptyStateSubtitle(): string {
    const messages: { [key: string]: string } = {
      'en': 'Publish your first {{language}} story and get the early-mover advantage. <a href="contest" class="redcolor">Click here for more info</a>.',
      'hi': 'अपनी पहली {{language}} कहानी प्रकाशित करें और early-mover advantage प्राप्त करें। <a href="contest" class="redcolor">अधिक माहितीसाठी इथे क्लिक करें</a>.',
      'mr': 'इथे तुमची कथा लिहा आणि मिळवा Funtel StoryFest चे प्रमाणपत्र आणि जिंका ₹5000 रुपये!<br>अटी व शर्ती लागू — <a href="contest" class="redcolor">अधिक माहितीसाठी इथे क्लिक करा</a>.',
      'bn': 'আপনার প্রথম {{language}} গল্প প্রকাশ করুন এবং early-mover advantage পান। <a href="contest" class="redcolor">আরও তথ্যের জন্য এখানে ক্লিক করুন</a>.',
      'ta': 'உங்கள் முதல் {{language}} கதையை வெளியிட்டு early-mover advantage பெறுங்கள். <a href="contest" class="redcolor">மேலும் தகவலுக்கு இங்கே கிளிக் செய்யவும்</a>.',
      'te': 'మీ మొదటి {{language}} కథను ప్రచురించండి మరియు early-mover advantage పొందండి. <a href="contest" class="redcolor">మరిన్ని వివరాలకు ఇక్కడ క్లిక్ చేయండి</a>.',

    };
    
    const languageNames: { [key: string]: string } = {
      'en': 'English',
      'hi': 'Hindi',
      'mr': 'Marathi', 
      'bn': 'Bengali',
      'ta': 'Tamil',
      'te': 'Telugu'
    };
    
    const languageName = languageNames[this.selectedLanguage] || 'English';
    return (messages[this.selectedLanguage] || messages['en']).replace('{{language}}', languageName);
  }

  getCategoryEmptyMessage(): string {
    const messages: { [key: string]: string } = {
      'en': 'No stories in this category yet.',
      'hi': 'इस श्रेणी में अभी तक कोई कहानियाँ नहीं हैं।',
      'mr': 'या श्रेणीत अद्याप कथा नाहीत.',
      'bn': 'এই বিভাগে এখনও কোন গল্প নেই।',
      'ta': 'இந்த வகையில் இன்னும் கதைகள் இல்லை.',
      'te': 'ఈ వర్గంలో ఇంకా కథలు లేవు.'
    };
    return messages[this.selectedLanguage] || messages['en'];
  }

  scrollLeft() {
    this.carousel.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight() {
    this.carousel.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }
loadSponsoredStories() {
  this.promotionService.getSponsoredStories().subscribe({
    next: (response: SponsoredStoriesResponse) => { // ✅ TYPE SPECIFY KAREIN
      console.log('📢 Sponsored Stories with Cost:', response);
      
      if (response.status === 'success' && response.sponsored_stories.length > 0) {
        this.sponsoredStories = response.sponsored_stories.map(story => ({
          ...story,
          isSponsored: true,
          sponsoredBadge: true,
          click_cost: response.click_cost // ✅ AB ERROR NAHI AAYEGA
        }));
        
        console.log('💰 Click Cost:', response.click_cost);
        console.log('📢 Sponsored stories loaded:', this.sponsoredStories.length);
      } else {
        console.log('ℹ️ No sponsored stories available or insufficient balance');
        this.sponsoredStories = [];
      }
    },
    error: (error) => {
      console.error('❌ Error loading sponsored stories:', error);
      this.sponsoredStories = [];
    }
  });
}
get sortedCategoryOrder(): string[] {
  return this.categoryOrder
    .filter(cat => this.categoryWiseStories[cat]?.length > 0)
    .sort((a, b) => {
      const countA = this.categoryWiseStories[a]?.length || 0;
      const countB = this.categoryWiseStories[b]?.length || 0;
      return countB - countA; // Descending order (highest first)
    });
}
// Update getAllStories - SPONSORED STORIES FIRST
// Update getAllStories - SPONSORED STORIES FIRST
getAllStories() {
  // ✅ FIX: Direct language code use karein, conversion nahi
  const langParam = this.selectedLanguage !== 'en' ? `?language=${this.selectedLanguage}` : '';
  
  console.log('🔄 Fetching New Releases stories with language:', this.selectedLanguage);
  
  this.http.get<any>(`https://stories.funtelstudio.com/storyapi/allstory.php${langParam}`, {
    withCredentials: true
  }).subscribe({
    next: (response) => {
      if (response.status === 'success') {
        const decorated = response.data.map((s: any) => this.decorateStory(s));

        // Featured stories
        this.featuredStories = decorated.filter((story: any) => story.story_action === 1);
        
        // ✅ IMPROVED: SPONSORED STORIES KO FIRST POSITION PE RAKHEIN
        let allStories = [...decorated];
        
        if (this.sponsoredStories.length > 0) {
          console.log('🔄 Adding', this.sponsoredStories.length, 'sponsored stories at FIRST position');
          
          // Sponsored stories ko decorate karein
          const sponsoredWithFlag = this.sponsoredStories.map(sponsoredStory => {
            // Find the complete story data from regular stories
            const completeStory = decorated.find(story => story.id === sponsoredStory.story_id);
            
            return {
              ...(completeStory || {}), // Regular story data
              ...sponsoredStory,        // Sponsored data (overwrite)
              id: sponsoredStory.story_id,
              isSponsored: true,
              sponsoredBadge: true,
              // ✅ IMPORTANT: Ensure promotion_id is properly set
              promotion_id: sponsoredStory.promotion_id,
              // Ensure required fields
              story_image: sponsoredStory.story_image || completeStory?.story_image,
              author_name: sponsoredStory.author_name || completeStory?.author_name,
              views: completeStory?.views || 0,
              average_rating: completeStory?.average_rating || 0
            };
          }).filter(story => story.id && story.promotion_id); // ✅ Filter stories with valid promotion_id

          console.log('🎯 Processed sponsored stories for New Releases:', sponsoredWithFlag);

          // Regular stories se sponsored stories remove karein (duplicate avoid)
          const regularStories = allStories.filter(story => 
            !this.sponsoredStories.some(sponsored => sponsored.story_id === story.id)
          );
          
          // ✅ SPONSORED STORIES KO FIRST POSITION PE ADD KAREIN
          allStories = [...sponsoredWithFlag, ...regularStories];
        }

        // Master list
        this.allLatestStories = allStories.sort(
          (a: any, b: any) =>
            new Date(b.created_at || b.story_created_at).getTime() -
            new Date(a.created_at || a.story_created_at).getTime()
        );

        // Subset lists - SPONSORED STORIES INCLUDED AT FIRST
        this.latestStories = this.allLatestStories.slice(0, 2);
        this.trendingStories = this.allLatestStories.slice(0, 6);
        this.stories = this.allLatestStories.slice(0, 12);

        console.log('📊 Final New Releases stories count:', {
          total: this.allLatestStories.length,
          sponsored: this.sponsoredStories.length,
          featured: this.featuredStories.length,
          trending: this.trendingStories.length,
          // ✅ DEBUG: Check sponsored stories in New Releases
          newReleasesSponsored: this.stories.filter(s => s.isSponsored).length,
          language: this.selectedLanguage
        });

        this.calculateTopAuthors(decorated);
        this.loadFollowStatus();
      }
    },
    error: (error) => {
      console.error('❌ New Releases API call failed:', error);
    }
  });
}

getStoriesForCategory(categoryStories: any[]): any[] {
    if (!categoryStories) return [];
    return categoryStories;
  }
goToCategory(categoryName: string, categoryId: string) {
  console.log('Navigating to category:', categoryName, categoryId);
  
  const slug = this.slugify(categoryName);
  
  // ✅ Language parameter add karein
  const language = this.languageService.getCurrentLanguage();
  const queryParams: any = {};
  
  if (language !== 'en') {
    queryParams.language = language;
  }
  
  this.router.navigate(['/category', categoryId, slug], { 
    queryParams: queryParams 
  });
}
// home.component.ts - SIMPLE ALTERNATIVE

// home.component.ts - CATEGORY MAPPING FIX

getAllCategoryStories() {
  // ✅ DIRECT LANGUAGE CODE USE KAREIN, NO CONVERSION NEEDED
  const langParam = this.selectedLanguage !== 'en' ? `&language=${this.selectedLanguage}` : '';
  
  console.log('🔄 getAllCategoryStories called with language:', this.selectedLanguage);
  console.log('📢 Available sponsored stories:', this.sponsoredStories);
  
  this.http.get<any>(`https://stories.funtelstudio.com/storyapi/category.php?with_stories=true${langParam}`, {
    withCredentials: true
  }).subscribe({
    next: (response) => {
      console.log("📊 Category API Response:", response);
      
      if (response.status === 'success') {
        const storyByCategory: { [key: string]: any[] } = {};
        const order: string[] = [];

        // ✅ PEHLE CATEGORY ID TO NAME MAPPING BANAYEIN
        const categoryIdToNameMap: { [key: string]: string } = {};
        response.data.forEach((cat: any) => {
          if (cat.category_id && cat.category_name) {
            categoryIdToNameMap[cat.category_id] = cat.category_name.trim();
          }
        });

        console.log('🗺️ Category ID to Name Mapping:', categoryIdToNameMap);

        for (const cat of response.data) {
          const catName = cat.category_name?.trim();
          const catId = cat.category_id;

          if (!catName || !catId || !cat.stories?.length) continue;

          console.log(`🔍 Processing category: ${catName} (ID: ${catId})`);

          // Stories ko language ke hisaab se filter karein
          let filteredStories = cat.stories
            .map((s: any) => this.decorateStory(s))
            .filter((story: any) => {
              if (!story.language) return true;
              const storyLangCode = this.languageService.getCodeFromDBValue(story.language);
              return storyLangCode === this.selectedLanguage;
            });

          console.log(`📚 Stories after language filter: ${filteredStories.length}`);

          // ✅ IMPROVED: Check sponsored stories using CATEGORY ID MAPPING
          if (this.sponsoredStories.length > 0) {
            
            // Find sponsored stories that belong to this category
            const categorySponsoredStories = this.sponsoredStories.filter(sponsored => {
              // Get the category name from sponsored story's category ID
              const sponsoredCategoryName = categoryIdToNameMap[sponsored.category];
              
              console.log(`🎯 Checking sponsored story ${sponsored.story_id}:`, {
                sponsoredCategoryId: sponsored.category,
                sponsoredCategoryName: sponsoredCategoryName,
                currentCategoryName: catName,
                matches: sponsoredCategoryName === catName
              });
              
              return sponsoredCategoryName === catName;
            });

            console.log(`💰 Sponsored stories in "${catName}":`, categorySponsoredStories.length, categorySponsoredStories);

            if (categorySponsoredStories.length > 0) {
              // Mark sponsored stories and add them at beginning
              const sponsoredWithFlag = categorySponsoredStories.map(sponsoredStory => {
                // Find the complete story data
                const completeStory = cat.stories.find((s: any) => s.id === sponsoredStory.story_id);
                
                const mergedStory = {
                  ...(completeStory || {}),
                  ...sponsoredStory,
                  id: sponsoredStory.story_id,
                  isSponsored: true,
                  sponsoredBadge: true,
                  category: catId, // Ensure category ID is set correctly
                  category_name: catName // Add category name
                };
                
                console.log(`🔄 Merged sponsored story:`, mergedStory);
                return mergedStory;
              });

              // Remove sponsored stories from regular stories to avoid duplicates
              const regularStories = filteredStories.filter(story => 
                !categorySponsoredStories.some(sponsored => sponsored.story_id === story.id)
              );

              // ✅ SPONSORED STORIES KO BEGINNING ME ADD KAREIN
              filteredStories = [...sponsoredWithFlag, ...regularStories];
              
              console.log(`🎉 Final arrangement for "${catName}": ${sponsoredWithFlag.length} sponsored + ${regularStories.length} regular`);
            }
          }

          if (filteredStories.length > 0) {
            storyByCategory[catName] = filteredStories;
            order.push(catName);
            
            // ✅ DEBUG: Check if sponsored stories are in final array
            const sponsoredInFinal = filteredStories.filter(s => s.isSponsored);
            console.log(`✅ "${catName}" final - Total: ${filteredStories.length}, Sponsored: ${sponsoredInFinal.length}`);
          }
        }

        this.categoryWiseStories = storyByCategory;
        this.categoryOrder = order;
        
        console.log('📋 FINAL Category Data:', this.categoryWiseStories);
      }
    },
    error: (error) => {
      console.error('❌ Category-wise API call failed:', error);
    }
  });
}
  // ---------------- categories ----------------
  getCategory() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      
    });
    this.http.get<any>('https://stories.funtelstudio.com/storyapi/category.php', { headers, withCredentials: true })
      .subscribe({
        next: (res) => {
          if (res.status === 'success') {
            this.categoryColumns = res.data.flat();
            this.visibleCategories = this.categoryColumns.slice(0, 12);
          }
        },
        error: (err) => console.error('Failed to fetch categories:', err)
      });
  }
  toggleCategories() {
    this.showAllCategories = !this.showAllCategories;
    this.visibleCategories = this.showAllCategories
      ? this.categoryColumns
      : this.categoryColumns.slice(0, 12);
  }
loadOtherLanguageStories() {
  // Sabhi languages ki stories load karein without filter
  this.http.get<any>('https://stories.funtelstudio.com/storyapi/allstory.php', {
    withCredentials: true
  }).subscribe({
    next: (response) => {
      if (response.status === 'success') {
        const allStories = response.data.map((s: any) => this.decorateStory(s));
        
        // Filter stories that are NOT in current language
        this.otherLanguageStories = allStories.filter((story: any) => {
          const storyLangCode = this.languageService.getCodeFromDBValue(story.language);
          return storyLangCode !== this.selectedLanguage;
        });

        // Sort by creation date (newest first)
        this.otherLanguageStories.sort((a: any, b: any) => 
          new Date(b.created_at || b.story_created_at).getTime() -
          new Date(a.created_at || a.story_created_at).getTime()
        );

        // Agar other language stories available hain to show karein
        this.showOtherLanguages = this.otherLanguageStories.length > 0;

        console.log(`📚 Loaded ${this.otherLanguageStories.length} stories from other languages`);
      }
    },
    error: (error) => {
      console.error('❌ Failed to load other language stories:', error);
      this.showOtherLanguages = false;
    }
  });
}
  // Add this method to get language name from code
  getLanguageName(languageCode: string): string {
    const languageNames: { [key: string]: string } = {
      'en': 'English',
      'hi': 'Hindi',
      'mr': 'Marathi', 
      'bn': 'Bengali',
      'ta': 'Tamil',
      'te': 'Telugu'
    };
    
    const code = this.languageService.getCodeFromDBValue(languageCode);
    return languageNames[code] || 'Unknown';
  }
  // ---------------- library / likes ----------------
  addToLibrary(storyId: number) {
    const userId = this.authService.getCurrentUserId();
    if (!userId) { this.router.navigate(['login']); return; }

    const alreadyLiked = this.likedStories.includes(storyId);
    const body = { user_id: userId, story_id: storyId, like_story: !alreadyLiked };

    this.http.post<any>('https://stories.funtelstudio.com/storyapi/addstory.php', body,{
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    }).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          if (!alreadyLiked) {
            this.likedStories.push(storyId);
            this.libraryMessage = 'Story added to library';
          } else {
            this.likedStories = this.likedStories.filter(id => id !== storyId);
            this.libraryMessage = 'Story removed from library';
          }
        } else if (res.status === 'removed') {
          this.likedStories = this.likedStories.filter(id => id !== storyId);
          this.libraryMessage = 'Story removed from library';
        } else {
          this.libraryMessage = res.message || 'Unexpected response';
        }
        setTimeout(() => this.libraryMessage = '', 3000);
      },
      error: () => console.error('Library action failed')
    });
  }

  loadLikedStories() {
    const userId = this.authService.getCurrentUserId();
    if (!userId) return;
    this.http.get<any>(`https://stories.funtelstudio.com/storyapi/allstory.php?action=library&user_id=${userId}`, { withCredentials: true })
      .subscribe({
        next: (res) => {
          if (res.status === 'success') {
            this.likedStories = res.data.map((item: any) => +item.id);
            console.log('Liked Stories:', this.likedStories);
          }
        },
        error: (err) => console.error('Failed to load liked stories:', err)
      });
  }

  // ---------------- top authors ----------------
  calculateTopAuthors(stories: any[]) {
  const authorMap: Record<string, {
    author_name: string;
    user_id: string;
    views: number;
    story_count: number;
    profileImg?: string;
  }> = {};

  console.log('🔍 Calculating top authors for Top Writers section...');

  // ✅ पहले अलग से API call करके सभी authors की actual story count लोड करें
  // Temporary storage for actual counts
  const authorStoryCounts: Record<string, number> = {};

  // पहले सभी लेखकों को इकट्ठा करें
  stories.forEach((story: any) => {
    const uid = story.user_id;
    if (!uid) return;
    
    if (!authorMap[uid]) {
      authorMap[uid] = {
        user_id: uid,
        author_name: story.author_name || 'Unknown',
        views: 0,
        story_count: 0, // Temporary count
        profileImg: story.authorProfileUrl || ''
      };
    }
  });

  // अब प्रत्येक लेखक के लिए views count करें
  stories.forEach((story: any) => {
    const uid = story.user_id;
    if (!uid || !authorMap[uid]) return;
    
    authorMap[uid].views += (+story.views || 0);
  });

  // ✅ अब हर author के लिए actual story count API से fetch करें
  const authorIds = Object.keys(authorMap);
  console.log(`📊 Fetching actual story counts for ${authorIds.length} authors...`);

  // Parallel API calls करें
  const requests = authorIds.map(authorId => {
    return new Promise<void>((resolve) => {
      this.http.get<any>(
        `https://stories.funtelstudio.com/storyapi/allstory.php?action=user&user_id=${authorId}`,
        { withCredentials: true }
      ).subscribe({
        next: (res) => {
          if (res.status === 'success' && res.data) {
            // Profile page की तरह language filter न लगाएं
            const allStories = res.data.filter((story: any) => story.user_id == authorId);
            authorStoryCounts[authorId] = allStories.length;
            
            console.log(`✅ Author ${authorMap[authorId].author_name} actual stories: ${allStories.length}`);
          } else {
            authorStoryCounts[authorId] = 0;
          }
          resolve();
        },
        error: (err) => {
          console.error(`Error loading stories for author ${authorId}:`, err);
          authorStoryCounts[authorId] = 0;
          resolve();
        }
      });
    });
  });

  // सभी API calls complete होने पर
  Promise.all(requests).then(() => {
    // अब actual story counts set करें
    authorIds.forEach(authorId => {
      if (authorMap[authorId]) {
        authorMap[authorId].story_count = authorStoryCounts[authorId] || 0;
      }
    });

    // Top authors को views के आधार पर sort करें
    this.topAuthors = Object.values(authorMap)
      .filter(author => author.story_count > 0)
      .sort((a, b) => b.views - a.views)
      .slice(0, 10);
    
    console.log('🎯 Final Top Authors with actual story counts:', this.topAuthors);
    
    // Follow status load करें
    this.loadFollowStatus();
  });
}

calculateTopAuthorsOptimized(stories: any[]) {
  console.log('🔍 Calculating top authors (Optimized)...');
  
  // पहले unique authors collect करें
  const uniqueAuthors = new Map<string, any>();
  
  stories.forEach((story: any) => {
    const uid = story.user_id;
    if (!uid) return;
    
    if (!uniqueAuthors.has(uid)) {
      uniqueAuthors.set(uid, {
        user_id: uid,
        author_name: story.author_name || 'Unknown',
        views: 0,
        story_count: 0,
        profileImg: story.authorProfileUrl || ''
      });
    }
    
    const author = uniqueAuthors.get(uid);
    author.views += (+story.views || 0);
  });
  
  // Convert to array
  const authorArray = Array.from(uniqueAuthors.values());
  
  // Sort by views
  const sortedAuthors = authorArray.sort((a, b) => b.views - a.views).slice(0, 10);
  
  // अब हर top author के लिए actual story count fetch करें
  sortedAuthors.forEach(author => {
    this.http.get<any>(
      `https://stories.funtelstudio.com/storyapi/allstory.php?action=user&user_id=${author.user_id}`,
      { withCredentials: true }
    ).subscribe({
      next: (res) => {
        if (res.status === 'success' && res.data) {
          // Profile page की तरह NO language filter
          const allStories = res.data.filter((story: any) => story.user_id == author.user_id);
          author.story_count = allStories.length;
          
          // Update the topAuthors array
          const index = this.topAuthors.findIndex(a => a.user_id === author.user_id);
          if (index !== -1) {
            this.topAuthors[index].story_count = allStories.length;
          }
        }
      },
      error: (err) => {
        console.error(`Error loading story count for author ${author.user_id}:`, err);
      }
    });
  });
  
  // Set initial topAuthors (temporary counts)
  this.topAuthors = sortedAuthors;
  console.log('📊 Initial Top Authors set (temporary counts):', this.topAuthors);
}
viewProfile(authorId: string) {
  this.router.navigate(['/profile', authorId]);
}
  loadFollowStatus() {
    const userId = this.authService.getCurrentUserId();
    if (!userId) return;
    for (const author of this.topAuthors) {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      this.http.post<any>(
        'https://stories.funtelstudio.com/storyapi/follow/check_follow.php',
        { follower_id: +userId, following_id: +author.user_id },
        { headers, withCredentials: true }
      ).subscribe({
        next: (res) => this.isFollowingMap[author.user_id] = !!res.isFollowing,
        error: (err) => console.error(`Error checking follow for ${author.user_id}:`, err)
      });
    }
  }

  toggleFollow(authorId: string) {
    const userId = this.authService.getCurrentUserId();
    if (!userId) { this.router.navigate(['login']); return; }

    const isFollowing = this.isFollowingMap[authorId];
    const apiUrl = isFollowing
      ? 'https://stories.funtelstudio.com/storyapi/follow/unfollow.php'
      : 'https://stories.funtelstudio.com/storyapi/follow/follow.php';
    const body   = { follower_id: +userId, following_id: +authorId };
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.http.post(apiUrl, body, { headers, withCredentials: true }).subscribe({
      next: () => this.isFollowingMap[authorId] = !isFollowing,
      error: (err) => console.error('Follow/Unfollow failed:', err)
    });
  }

  // ---------------- progress ----------------
  loadUserStoryProgress() {
    const userId = this.authService.getCurrentUserId();
    if (!userId) return;
    const key = `story_progress_${userId}`;
    const data = localStorage.getItem(key);
    if (!data) return;

    const progress = JSON.parse(data);
    this.userProgress = [];

    for (const [storyId, entry] of Object.entries(progress) as any) {
      const percent = Math.round((entry.readParts.length / entry.totalParts) * 100);
      this.http.get<any>(`https://stories.funtelstudio.com/storyapi/allstory.php?id=${storyId}`,{withCredentials:true}).subscribe({
        next: (res) => {
          if (res.status === 'success' && res.data?.length) {
            const storyData = res.data.find((s: any) => s.id == +storyId);
            this.userProgress.push({
              storyId,
              title: entry.lastPartTitle,
              lastReadPartId: entry.lastReadPartId,
              percent,
              part: entry.readParts.length,
              total: entry.totalParts,
              timestamp: entry.timestamp,
              image: this.fullAsset(storyData.story_image)
            });
            this.userProgress.sort((a, b) => b.timestamp - a.timestamp);
          }
        },
        error: (err) => console.error(`Failed to fetch story info for ${storyId}`, err)
      });
    }
  }

  // ---------------- misc helpers ----------------
  resumeReading(storyId: number, title: string) {
    const slug = this.slugify(title);
    this.router.navigate(['/series', `${storyId}-${slug}`]);
  }
  goToSeries(storyId: string, title: string) {
    const slug = this.slugify(title);
    this.router.navigate(['/story', `${storyId}-${slug}`]);
  }
  slugify(text: string): string {
    return translitSlug(text, { lowercase: true, separator: '-' });
    return text.toLowerCase().trim().replace(/[\s\W-]+/g, '-').replace(/^-+|-+$/g, '');
  }

  getProgress(storyId: number): number {
    const progress = this.userProgress.find(p => p.storyId == storyId);
    return progress ? progress.percent : 0;
  }

  getTotalReadingTime(): number {
    return this.stories.reduce((sum, s) => sum + (s.readTime || 0), 0);
  }
  formatTotalReadTime(minutes: number): string {
    if (minutes >= 10080) { const weeks = Math.floor(minutes / 10080); const rem = minutes % 10080; return `${weeks} week${weeks>1?'s':''}` + (rem?` ${this.formatTotalReadTime(rem)}`:''); }
    if (minutes >= 1440)  { const days  = Math.floor(minutes / 1440); const rem = minutes % 1440; return `${days} day${days>1?'s':''}` + (rem?` ${this.formatTotalReadTime(rem)}`:''); }
    if (minutes >= 60)    { const hrs   = Math.floor(minutes / 60);   const rem = minutes % 60;   return `${hrs} hr${hrs>1?'s':''}` + (rem?` ${rem} min`:''); }
    return `${minutes} min`;
  }
  getTotalViews(): number {
    return this.stories.reduce((sum, s) => sum + (s.views || 0), 0);
  }
 // home.component.ts - FIXED formatCount function
formatCount(num: number | undefined | null): string {
  // ✅ ADD NULL CHECK
  if (num === undefined || num === null) {
    return '0';
  }
  
  // ✅ ENSURE IT'S A NUMBER
  const numberValue = Number(num);
  
  if (isNaN(numberValue)) {
    return '0';
  }
  
  if (numberValue >= 1_000_000) return (numberValue / 1_000_000).toFixed(1) + 'M';
  if (numberValue >= 1_000) return (numberValue / 1_000).toFixed(1) + 'K';
  return numberValue.toString();
}
onStoryClick(story: any) {
  console.log('🎯 Story clicked:', story);
  
  // Agar sponsored story hai to interaction record karein
  if (story.isSponsored && story.promotion_id) {
    this.recordSponsoredClick(story.promotion_id);
  }
  
  // Normal navigation
  this.goToSeries(story.id, story.story_title);
}

// home.component.ts - FIXED VERSION

// Sponsored click record karein - WITH NULL HANDLING
recordSponsoredClick(promotionId: number) {
  console.log('💰 Recording click for promotion:', promotionId);
  
  // ✅ SIMPLE: No need for viewer user ID
  this.promotionService.recordInteraction(promotionId, 'click').subscribe({
    next: (response) => {
      console.log('✅ Click recorded successfully:', response);
      
      if (response.remaining_balance !== undefined) {
        console.log('💰 Remaining promotion balance:', response.remaining_balance);
      }
    },
    error: (error) => {
      console.error('❌ Error recording click:', error);
    }
  });
}

// View record karein (agar needed ho) - SAME FIX
recordSponsoredView(promotionId: number) {
  this.promotionService.recordInteraction(promotionId, 'view').subscribe({
    next: (response) => {
      console.log('✅ View recorded:', response);
    },
    error: (error) => {
      console.error('❌ Error recording view:', error);
    }
  });
}
  toggleSeeMore() {
  this.showAllLatest = !this.showAllLatest;
  this.latestStories = this.showAllLatest
    ? this.allLatestStories
    : this.allLatestStories.slice(0, 6);
}
setupMouseDrag() {
    const carousel = this.carousel.nativeElement;
    
    // Prevent image drag
    const images = carousel.querySelectorAll('img');
    images.forEach((img: HTMLImageElement) => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  onMouseDown(event: MouseEvent) {
    const carousel = this.carousel.nativeElement;
    
    this.isMouseDown = true;
    carousel.classList.add('active:cursor-grabbing');
    this.startX = event.pageX - carousel.offsetLeft;
    this.scrollLeft = carousel.scrollLeft;
    this.velocity = 0;
    this.lastX = event.pageX;
    this.timestamp = Date.now();
    
    event.preventDefault();
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isMouseDown) return;
    
    const carousel = this.carousel.nativeElement;
    const x = event.pageX - carousel.offsetLeft;
    const walk = (x - this.startX) * 2; // Scroll speed multiplier
    
    // Calculate velocity for momentum
    const now = Date.now();
    const deltaTime = now - this.timestamp;
    if (deltaTime > 0) {
      const deltaX = event.pageX - this.lastX;
      this.velocity = deltaX / deltaTime;
    }
    
    this.lastX = event.pageX;
    this.timestamp = now;
    
    // carousel.scrollLeft = this.scrollLeft - walk;
    event.preventDefault();
  }

  onMouseUp() {
    this.isMouseDown = false;
    this.carousel.nativeElement.classList.remove('active:cursor-grabbing');
    
    // Apply momentum scrolling
    this.applyMomentum();
  }

  applyMomentum() {
    if (Math.abs(this.velocity) < 0.1) return;
    
    const carousel = this.carousel.nativeElement;
    const momentum = this.velocity * 1000; // Momentum multiplier
    
    const animate = () => {
      this.velocity *= 0.95; // Friction
      carousel.scrollLeft -= this.velocity * 16;
      
      if (Math.abs(this.velocity) > 0.1) {
        this.rafId = requestAnimationFrame(animate);
      } else {
        this.velocity = 0;
      }
    };
    
    this.rafId = requestAnimationFrame(animate);
  }

  onScroll() {
    // Reset velocity when user manually scrolls
    this.velocity = 0;
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  // Update existing scroll methods


  // Cleanup
  ngOnDestroy() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  }
}